import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { RefreshActions } from '../../../../state/refresh'
import { ProjectWithComments } from '../../../../types/project'
import { useRequests } from '../../../../requests/useRequests'

interface ProjectDetailsFormProps {
  project: ProjectWithComments
  onProjectUpdate: (updatedProject: ProjectWithComments) => void
}

const ProjectDetailsForm: React.FC<ProjectDetailsFormProps> = ({
  project,
  onProjectUpdate
}) => {
  const requestMaker = useRequests()
  const dispatch = useDispatch()

  const [clientName, setClientName] = React.useState('')
  const [clientEmail, setClientEmail] = React.useState('')
  const [clientPhone, setClientPhone] = React.useState('')
  const [budget, setBudget] = React.useState<number | null>(null)
  const [status, setStatus] = React.useState('in_progress')
  const [companyName, setCompanyName] = React.useState('')
  const [companyNip, setCompanyNip] = React.useState('')
  const [companyAddress, setCompanyAddress] = React.useState('')

  useEffect(() => {
    if (project) {
      setClientName((project as any).clientName || '')
      setClientEmail((project as any).clientEmail || '')
      setClientPhone((project as any).clientPhone || '')
      setBudget(typeof (project as any).budget === 'number' ? (project as any).budget : null)
      setStatus((project as any).status || 'in_progress')
      setCompanyName((project as any).companyName || '')
      setCompanyNip((project as any).companyNip || '')
      setCompanyAddress((project as any).companyAddress || '')
    }
  }, [project])

  const handleUpdateProjectDetails = async () => {
    const success = await requestMaker.updateProject(project.id, {
      clientName,
      clientEmail,
      clientPhone,
      budget,
      status,
      companyName,
      companyNip,
      companyAddress
    })

    if (success) {
      const updatedProject = await requestMaker.getProject(project.id)
      if (updatedProject) {
        onProjectUpdate(updatedProject.data as ProjectWithComments)
        dispatch(
          RefreshActions.setToastMessage({
            message: 'Dane projektu zostały zaktualizowane'
          })
        )
      }
    }
  }

  return (
    <div className='row mb-30'>
      <div className='col-sm-12'>
        <div className='card p-20'>
          <div className='projectCard'>
            <h5 className='tw-font-semibold'>Szczegóły projektu</h5>
            <div className='row mt-3'>
              <div className='col-md-6'>
                <div className='form-group'>
                  <label>Imię i nazwisko inwestora</label>
                  <input
                    type='text'
                    className='form-control'
                    value={clientName}
                    onChange={(e) => setClientName(e.target.value)}
                    placeholder='Wprowadź imię i nazwisko inwestora'
                  />
                </div>
              </div>
              <div className='col-md-6'>
                <div className='form-group'>
                  <label>Budżet (PLN)</label>
                  <input
                    type='number'
                    className='form-control'
                    value={budget || ''}
                    onChange={(e) => setBudget(e.target.value ? parseFloat(e.target.value) : null)}
                    placeholder='Wprowadź budżet projektu'
                  />
                </div>
              </div>
            </div>
            <div className='row mt-2'>
              <div className='col-md-6'>
                <div className='form-group'>
                  <label>Email</label>
                  <input
                    type='email'
                    className='form-control'
                    value={clientEmail}
                    onChange={(e) => setClientEmail(e.target.value)}
                    placeholder='Wprowadź email'
                  />
                </div>
              </div>
              <div className='col-md-6'>
                <div className='form-group'>
                  <label>Telefon</label>
                  <input
                    type='tel'
                    className='form-control'
                    value={clientPhone}
                    onChange={(e) => setClientPhone(e.target.value)}
                    placeholder='Wprowadź telefon'
                  />
                </div>
              </div>
            </div>
            <div className='row mt-2'>
              <div className='col-md-4'>
                <div className='form-group'>
                  <label>Nazwa firmy</label>
                  <input
                    type='text'
                    className='form-control'
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    placeholder='Wprowadź nazwę firmy'
                  />
                </div>
              </div>
              <div className='col-md-4'>
                <div className='form-group'>
                  <label>NIP</label>
                  <input
                    type='text'
                    className='form-control'
                    value={companyNip}
                    onChange={(e) => setCompanyNip(e.target.value)}
                    placeholder='Wprowadź NIP firmy'
                  />
                </div>
              </div>
              <div className='col-md-4'>
                <div className='form-group'>
                  <label>Adres</label>
                  <input
                    type='text'
                    className='form-control'
                    value={companyAddress}
                    onChange={(e) => setCompanyAddress(e.target.value)}
                    placeholder='Wprowadź adres'
                  />
                </div>
              </div>
            </div>
            <div className='row mt-2'>
              <div className='col-md-6'>
                <div className='form-group'>
                  <label>Status projektu</label>
                  <select
                    className='form-control'
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value='in_progress'>W realizacji</option>
                    <option value='completed'>Zakończony</option>
                  </select>
                </div>
              </div>
            </div>
            <div className='d-flex justify-content-end mt-3'>
              <button
                type='button'
                className={`
                                      tw-mr-2 tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors
                                      tw-text-white
                                      tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-green hover:tw-bg-opacity-90 focus:tw-bg-green
                                    `}
                onClick={handleUpdateProjectDetails}
              >
                Zapisz zmiany
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProjectDetailsForm
